const customStyles = {
  control: (base, state) => ({
    ...base,
    "*": {
      boxShadow: "none !important",
    },
    colors: {
      primary: "#090a3a",
    },
  }),
};

export default customStyles;
